import "./TrialInformation.css";

import { Col, Row } from "reactstrap";
import { MAP_DISPLAY_MODES, isResultsTab } from "../../../../constants";
import { useDispatch, useSelector } from "react-redux";

import FieldMapDetails from "./FieldMapDetails";
import { PlotMapDetails } from "./PlotMapDetails";
import { TrialPreferences } from "../TrialPreferences/TrialPreferences";
import { setMapDisplayMode } from "../../../../actions/resultMap";

export const TrialInformation = () => {
  const [mapDisplayMode, traitsListForMap, features] = useSelector((state) => [
    state.resultMap.mapDisplayMode,
    state.resultMap.traitsListForMap,
    state.resultMap.features,
  ]);

  const dispatch = useDispatch();
  const trialItems = [
    {
      id: MAP_DISPLAY_MODES.FIELD_MAP,
      title: "Field Map",
      component: <FieldMapDetails />,
    },
    {
      id: MAP_DISPLAY_MODES.PLOT_MAP,
      title: "Plot Map",
      component: <PlotMapDetails />,
      disabled: features.length === 0,
    },
    {
      id: MAP_DISPLAY_MODES.RESULTS,
      title: "Results",
      component: <TrialPreferences onMap />,
      // Field Book is folded into Results: one tab for the trait and the
      // attribute colours. Enabled on plots alone, or a site with no results
      // yet would lose its attribute colours.
      disabled: features.length === 0,
    },
  ];

  const isSelected = (item) =>
    item.id === MAP_DISPLAY_MODES.RESULTS
      ? isResultsTab(mapDisplayMode)
      : mapDisplayMode === item.id;

  return (
    <Row className="h-100 m-0">
      <Col className="trial-items trial-items--vertical p-1">
        <Row className="g-1" sm={1}>
          {trialItems.map((item) => (
            <Col key={item.id}>
              <div
                className={`trial-card p-1 ${
                  !item.disabled ? "clickable" : "disabled"
                } ${isSelected(item) ? "selected" : ""}`}
                onClick={() => {
                  if (item.disabled || isSelected(item)) return;
                  // Results opens on the trait colours when there are
                  // results, on the attribute colours otherwise.
                  const mode =
                    item.id === MAP_DISPLAY_MODES.RESULTS &&
                    traitsListForMap.length === 0
                      ? MAP_DISPLAY_MODES.FIELD_BOOK
                      : item.id;
                  dispatch(setMapDisplayMode(mode));
                }}
              >
                <span className="fw-normal">{item.title}</span>
                <div className={`diorama diorama-${item.id}`} />
              </div>
            </Col>
          ))}
        </Row>
      </Col>
      <Col className="trial-items-content">
        {trialItems.find((item) => isSelected(item))?.component}
      </Col>
    </Row>
  );
};
